import { ApolloClient, useApolloClient } from '@apollo/client';

export function useApolloCacheUpdater<Query extends {}>(
  query: Parameters<ApolloClient<object>['readQuery']>[0]['query'],
  variables: Parameters<ApolloClient<object>['readQuery']>[0]['variables']
) {
  const apolloClient = useApolloClient();
  return {
    getOldData: () => {
      return apolloClient.readQuery({
        query,
        variables,
      }) as Query | null;
    },
    updateData: (newData: Query | null) =>
      apolloClient.writeQuery({
        query,
        data: newData,
        variables,
      }),
  };
}
